import { createContext, useState, useEffect } from "react";

export const ResponsaveisContext = createContext()

export function ResponsaveisProvider({children}){
    const [responsaveis, setResponsaveis] = useState([])

    const buscarResponsaveis = async () => {
        const API_URL = process.env.REACT_APP_API_URL;

        try{
            console.log("Buscando os responsaveis")
            const url = `${API_URL}/buscaresponsaveis`
            const response = await fetch(url)
            const data = await response.json()
            setResponsaveis(data)
        } catch(error){
            console.log("erro: ", error)
        }
    }

    useEffect(() => {
        buscarResponsaveis()
    }, [])

    return(
        <ResponsaveisContext.Provider value={{responsaveis, setResponsaveis, buscarResponsaveis}}>
            {children}
        </ResponsaveisContext.Provider>
    )
}
